import { GlobalManager } from '@/context'
import { JudgePopupType } from '../../common/util/judgePopupType'
import { ReceiveLogPopSwitchEnum } from '@/api/event/type'
import { WaitingGetStore } from '.'
import { useMainStore } from '@/store/index'
import { userRecord } from './initState/userOpeningWaitingGetRecord'
export type OpenModalParams = {
  store: WaitingGetStore
  /** 是否登录触发 */
  isLoginTrigger: boolean
  /** 是否刷新数据 */
  isFreshData: boolean
}
/** 打开待领取弹窗 */
export const proxyOpenWaitingGetModal = async (params: OpenModalParams) => {
  const { store, isFreshData, isLoginTrigger } = params

  // 判断后台配置 必须登陆后
  const { activesAuthInfos, hasLogined } = useMainStore()
  let isOpenable =
    activesAuthInfos.disableReceiveLogPop !== ReceiveLogPopSwitchEnum.NoPop &&
    hasLogined
  if (!isOpenable) {
    return
  }

  // 先判断用户勾选
  isOpenable = await judgeIsOpenableModalByChecked(store, isFreshData)
  if (!isOpenable) {
    return
  }
  // 根据后台配置的弹窗类型对应相关数据来判断当前是否弹出
  isOpenable = JudgePopupType.waitingGet.run({ isLoginTrigger })
  if (!isOpenable) {
    return
  }
  // 打开弹窗，关暂停，需要等弹窗关闭时，才结束暂停
  await new Promise((resolve) => {
    // 打开弹窗
    GlobalManager.Modal.open('waitingGet').then((context) => {
      //重点,环境监听,只能使用$once,不然会重复监听越来越多的内容
      context.$once('modal:close', () => {
        resolve(undefined)
      })
    })
  })
}
/**
 * @deprecated 走不同的弹窗配置类型了,该函数可能不再需要了.
 * 判断弹窗是否可以打开,通过是否有待[领取/完成]奖项 */
export const judgeIsOpenableModalByRewardList = (store: WaitingGetStore) => {
  if (
    store.pendingRewardList?.length === 0 &&
    store.collectTomorrowList?.length === 0 &&
    store.receivedTodayList?.length === 0
  ) {
    return false
  } else {
    return true
  }
}

/** 判断弹窗是否可以打开,通过checked选项 */
const judgeIsOpenableModalByChecked = async (
  store: WaitingGetStore,
  isFreshData: boolean
) => {
  let isDisablePop = judgeUserCheckedDisabled(store)
  if (isDisablePop) {
    return false
  }
  // 如果选中了需要请求数据刷新,则拿到数据后再进行一轮判断
  if (isFreshData) {
    await store.freshPopData()
    // 更新数据后,需要再次判断,因为后台可能会返回永久禁用的状况
    isDisablePop = judgeUserCheckedDisabled(store)
    if (isDisablePop) {
      return false
    }
  }
  return true
}

/** 判断用户是否勾选了禁用弹框 */
const judgeUserCheckedDisabled = (store: WaitingGetStore) => {
  // 后台禁用本项|勾选永不提示|勾选本次不提示|业务层面要求只弹一次,任何一个为true则不再弹框
  const { isNeverRemind } = store
  // 后台配置的,不显示弹窗
  const { isServerDisabled } = store
  // 是否勾选过今日不再弹出 今日是否已经弹出过
  const { isHaveOpenedToday, isCheckDayNoOpen } =
    userRecord.getUserOpeningRecord()
  if (
    isNeverRemind ||
    (isHaveOpenedToday && isCheckDayNoOpen) ||
    isServerDisabled
  ) {
    return true
  } else {
    return false
  }
}
